var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('md-progress-spinner',{attrs:{"md-diameter":50,"md-stroke":3,"md-mode":"indeterminate"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }